/**
 * Local Docker Desktop / kind ingress helpers.
 * NodePorts are not published on this cluster — use port-forward :8443 for HTTPS.
 */

/** Rewrite bare https://*.local URLs to include the ingress port-forward port. */
export const withLocalIngressPort = (url, port = 8443) => {
  if (!url) return url;
  try {
    const u = new URL(url);
    const host = u.hostname.toLowerCase();
    if ((host.endsWith('.local') || host.endsWith('.localhost')) && !u.port) {
      u.protocol = 'https:';
      u.port = String(port);
    }
    return u.toString();
  } catch {
    return url;
  }
};

export const openTenantServiceUrl = (url) => {
  const href = withLocalIngressPort(url);
  if (href) window.open(href, '_blank', 'noopener,noreferrer');
};
